import { render } from "./Index.vue?vue&type=template&id=68401d66&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=68401d66&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-68401d66"

export default script